<template>
  <div class="list-container">
    <headerComponent />
    <div class="list-box">
      <my-content-head>
        <div slot="left"
             class="left-content">
          <i-input size="large"
                   suffix="ios-search"
                   v-model="limitQuery.query"
                   @keyup.enter.native="initLoadTable"
                   placeholder="请输入学生姓名/学号"
                   style="width: 210px"
                   clearable
                   @on-clear="initLoadTable" />
          <i-button size="large"
                    @click="initLoadTable">查询</i-button>
            <i-select v-model="limitQuery.nf"
                    style="width:200px"
                    @on-change="njChange"
                    size="large">
            <i-option v-for="item in nfList"
                      :value="item"
                      :key="item">{{ item }}</i-option>
          </i-select>
          <i-select v-model="limitQuery.organizationId"
                    style="width:200px"
                    @on-change="getZyList"
                    size="large">
            <i-option v-for="item in xyList"
                      :value="item.value"
                      :key="item.label">{{ item.label }}</i-option>
          </i-select>
          <i-select v-model="limitQuery.majorId"
                    style="width:200px"
                    @on-change="initLoadTable"
                    size="large">
            <!-- <i-option value="">全部专业</i-option> -->
            <i-option v-for="item in zyList"
                      :value="item.value"
                      :key="item.label">{{ item.label }}</i-option>
          </i-select>
         
        </div>
        <div slot="right">
          <i-upload action="/postal/api/admin/import"
                    :show-upload-list="false"
                    :on-success="handleSuccess">
            <i-button type="primary"
                      ghost>导入</i-button>
          </i-upload>
          <i-button ghost
                    type="primary"
                    @click="exportExl">导出</i-button>
        </div>
      </my-content-head>
      <div class="content">
        <i-table :height="tableHeight"
                 :data="tableData"
                 :columns="colOption"
                 :border="true"
                 :loading="loading"></i-table>
      </div>
      <my-pagination @paginate="handlePaginate"
                     :pageSize="limitQuery.pageSize"
                     :pageNum="limitQuery.pageNum"
                     :msgCount="msgCount"></my-pagination>
    </div>
  </div>
</template>
<script>
import headerComponent from '../components/headerNav';
import myPagination from "@/components/myPagination";
import myContentHead from "@/components/myContentHead";
export default {
  name: 'list',
  components: {
    headerComponent,
    myPagination,
    myContentHead
  },
  data () {
    return {
      loading: false,
      // 消息总数量
      msgCount: 0,
      // 表格展示的数据
      tableData: [],
      limitQuery: {
        query: "",
        majorId: '',
        organizationId: '',
        nf:'全部年份',
        pageSize: 15,
        pageNum: 1,
      },
      xyList: [],
      zyList: [],
      nfList:[],
      colOption: [
        { title: "学号", align: "center", key: "stuNumber", tooltip: true },
        // {
        //   title: "日志类型",
        //   align: "center",
        //   key: "logType",
        //   width: 120,
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "strong",
        //         this.$getListValue(params.row.logType, this.logTypeList)
        //       )
        //     ]);
        //   },
        //   tooltip: true
        // },
        { title: "姓名", align: "center", key: "stuName", tooltip: true },
        { title: "学院", align: "center", key: "organizationName", tooltip: true },
        {
          title: "专业",
          align: "center",
          key: "majorName",
          tooltip: true
        },
        {
          title: "证件号码",
          align: "center",
          key: "card",
          tooltip: true
        },
        {
          title: "考生编号",
          align: "center",
          key: "examNumber",
          tooltip: true
        },
        {
          title: "通讯地址",
          align: "center",
          key: "adress",
          tooltip: true
        },
        {
          title: "邮政编号",
          align: "center",
          key: "postalNumber",
          tooltip: true
        },
        {
          title: "联系电话",
          align: "center",
          key: "phone",
          tooltip: true
        },
        {
          title: "是否修改",
          align: "center",
          key: "updated",
          tooltip: true,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                params.row.updated == 1 ? '是' : '否'
              )
            ]);
          }
        },
        {
          title: "是否登录",
          align: "center",
          key: "login",
          tooltip: true,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                params.row.login == 1 ? '是' : '否'
              )
            ]);
          }
        }
      ],
      tableHeight: 700
    }
  },
  created () {
    // this.getXyList();
    this.initLoadTable()
    this.getNjList()
  },
  methods: {
    getXyList () {
      this.$axios.get(`/api/admin/organization/${this.limitQuery.nf}`).then(res => {
         this.xyList = res.data.data;
        //  this.xyList.unshift({value:'',label:"全部学院"})
         this.limitQuery.organizationId=this.xyList[0].value
      })
    },
    getZyList () {
      this.$axios.get(`/api/admin/major?organizationId=${this.limitQuery.organizationId}`).then(res => {
        this.zyList = res.data.data;
      })
      this.limitQuery.majorId = ''
      this.initLoadTable()
    },
    getNjList(){
      this.$axios.get('/api/admin/getYear').then(res => {
        this.nfList = res.data.data;     
        this.limitQuery.nf=this.nfList[0]
      })
      // if( this.limitQuery.nf=="全部年份"){
      //     return
      // }else{
      //   this.getXyList()
      // }
      this.getXyList()
     
    },
    njChange(){
       this.getXyList()
       this.initLoadTable()
    },
    // 查询时初始化查询当前页
    initLoadTable () {
      this.limitQuery.pageNum = 1;
      this.loadTable();
    },
    loadTable () {
      let tmpObj = { ...this.limitQuery };
      // 列表加载状态
      this.loading = true;
      // 发送请求列表数据的请求
      this.$axios
        .post("/api/admin/student", tmpObj)
        .then(res => {
          // 取消列表加载状态
          this.loading = false;
          let data = res.data.data;
          // 获得的参数验证
          if (!data || !Array.isArray(data.list)) {
            console.error("列表数据获取失败");
            return false;
          }
          // 保存总条数
          this.msgCount = data.total;
          // 保存列表数据
          this.tableData = data.list;
        })
        .catch(error => {
          console.error(error.message);
          // 取消列表加载状态
          this.loading = false;
        });
    },
    // 接收分页组件传递的分页数据，并调用加载数据方法
    handlePaginate (page) {
      // 解构出分页数据
      let { pageSize, pageNum } = page;
      // 保存到pageList中
      if (pageNum !== undefined) {
        this.limitQuery.pageNum = pageNum;
      }
      if (pageSize !== undefined) {
        this.limitQuery.pageSize = pageSize;
      }
      // 重新请求列表数据
      this.loadTable();
    },
    exportExl () {
      let params={
        nf:this.limitQuery.nf,
        query:this.limitQuery.query
      }
      this.$handleDown(params, `/api/admin/exportStu`)
    },
    handleSuccess (res, file) {
      console.log(res)
      if (res.code == 10000) {
        this.loadTable()
      } else {
        this.$Message.error(res.msg)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.list-container {
  width: 100%;
  height: 100%;
  background: #f2f2f2;
  .list-box {
    width: 80%;
    padding: 0 10px;
    box-sizing: border-box;
    margin-left: 10%;
    height: calc(100% - 80px);
    overflow-y: auto;
    background: #fff;
    .header-box {
      width: 100%;
      height: 50px;
      display: flex;
      align-self: center;
      justify-content: space-between;
    }
  }
}
</style>